import { getJwt } from '@app/helpers';
import Axios from 'axios';
import api from './api';

export interface ContabilidadeGeralModel {
  contabilidadePendentes: ContabilidadeTableModel;
  contabilidadeBaixados: ContabilidadeTableModel;
  contabilidadeRecusados: ContabilidadeTableModel;
  contabilidadeIntegrados: ContabilidadeTableModel;
  contabilidadeCancelados: ContabilidadeTableModel;
}

export interface ContabilidadeTableModel {
  idArquivoAutorizacao: string;
  arquivoComprovanteCancelamentoId: string;
  nomeArquivoComprovanteCancelamento: string;
  numeroFornecedor: number;
  numeroContrato: number;
  cnpjFornecedor: string;
  razaoSocialFornecedor: string;
  numeroTotvs: string;
  tipoArquivoAutorizacao: string;
  valorArquivoAutorizacao: number;
  creditoPisCofins: boolean;
  dataUploadArquivo: string;
  statusContabilidadeGeral: string;
  statusFaturamento: string;
  codigoStatusContabilidadeGeral: number;
  codigoStatusFaturamento: number;
  nomeArquivo: string;
  arquivoCartaCorrecaoId: string;
  nomeArquivoCartaCorrecao: string;
  comentarios: number;
  condicaoPagamento: string;
  responsavelVisaoBaixado: string;
  responsavelVisaoRecusado: string;
  numeroBm: number;
}

export const getAllContabilidadeGeral = (periodo: any) =>
  api.post<ContabilidadeGeralModel>(`contabilidadeGeral`, periodo, { disableNotification: 'true' });

export const viewArquivoAutorizacao = async (id: string) => {
  var url = window.location.origin + `/api/contabilidadeGeral/downloadArquivoAutorizacao/${id}`;
  await Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(response => {
    const file = new Blob([response.data], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    var resp = window.open(fileURL);
  });
};

export const downloadArquivoAutorizacao = async (id: string, filename: string) => {
  var url = window.location.origin + `/api/contabilidadeGeral/downloadArquivoAutorizacao/${id}`;
  await Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(resp => {
    const url = window.URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    link.setAttribute('id', 'downloadElement');
    document.body.appendChild(link);
    link.click();
    document.getElementById('downloadElement').outerHTML = '';
  });
};

export const viewArquivoCartaCorrecao = async data => {
  var url =
    window.location.origin +
    `/api/contabilidadeGeral/downloadArquivoCartaCorrecao/${data.arquivoAutorizacaoId}/${data.arquivoCartaCorrecaoId}`;
  await Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(response => {
    const file = new Blob([response.data], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    var resp = window.open(fileURL);
  });
};

export const downloadArquivoCartaCorrecao = async data => {
  var url =
    window.location.origin +
    `/api/contabilidadeGeral/downloadArquivoCartaCorrecao/${data.arquivoAutorizacaoId}/${data.arquivoCartaCorrecaoId}`;
  await Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(resp => {
    const url = window.URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', data.filename);
    link.setAttribute('id', 'downloadElement');
    document.body.appendChild(link);
    link.click();
    document.getElementById('downloadElement').outerHTML = '';
  });
};

export const confirmarIntegracao = (data: any) => {
  return api.post('contabilidadeGeral/confirmarIntegracao', data);
};

export const recusarDocumento = (data: any) => {
  return api.post('contabilidadeGeral/recusarDocumento', data);
};

export const excluirDocumento = (data: any) => {
  return api.post('contabilidadeGeral/excluirDocumento', data, {
    disableNotification: 'true',
  });
};

export const viewArquivoComprovanteCancelamento = async data => {
  var url =
    window.location.origin +
    `/api/contabilidadeGeral/downloadArquivoComprovanteCancelamento/${data.arquivoAutorizacaoId}/${data.arquivoComprovanteCancelamentoId}`;
  await Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(response => {
    const file = new Blob([response.data], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);
    var resp = window.open(fileURL);
  });
};

export const downloadArquivoComprovanteCancelamento = async data => {
  var url =
    window.location.origin +
    `/api/contabilidadeGeral/downloadArquivoComprovanteCancelamento/${data.arquivoAutorizacaoId}/${data.arquivoComprovanteCancelamentoId}`;
  await Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(resp => {
    const url = window.URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', data.filename);
    link.setAttribute('id', 'downloadElement');
    document.body.appendChild(link);
    link.click();
    document.getElementById('downloadElement').outerHTML = '';
  });
};
